export default function Trattative() {
  return (
    <main className="content">
      <div className="page__header">
        <div className="page__title-wrap">
          <h1 className="page__title">Trattative</h1>
          <p className="page__sub">Pratiche in fase di negoziazione o offerta</p>
        </div>
      </div>

      <div className="placeholder">
        <div className="placeholder__inner">
          <div className="placeholder__title">In arrivo</div>
          <div className="placeholder__body">
            La gestione delle trattative verrà progettata nei prossimi step.
          </div>
          <div className="placeholder__hint">
            <span className="dot"></span> placeholder · in attesa di modello dati
          </div>
        </div>
      </div>
    </main>
  );
}
